// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { getProp } from "@insite/mobius/utilities";
import { cartLinkStyles } from "@sc/Overrides/Widgets/Common/CartLink";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

cartLinkStyles.tippyStyles = {
    drawerContent: {
        css: css`
            min-width: 464px;
            width: 464px;
            border-radius: 0;
            height: 100%;
            max-height: initial;
            background-color: ${getColor("common.white")};
            display: flex;
            flex-direction: column;
            border: 1px solid ${color("common.border")};
            z-index: ${getProp("theme.zIndex.modal")};

            #mini-cart {
                height: 100%;
            }

            #mini-cart > div {
                height: 100%;
            }
        `,
    },
    drawerClose: {
        css: css`
            display: none;
        `,
    },
};
